import * as yup from 'yup'
import { PortOfEntryDto } from './portOfEntryDto'
import { PortOfLadingDto } from './portOfLadingDto'
import { ImportBranchDto } from './importBranchDto'

export class InboundTripImportBranchDto {
  importBranch?: ImportBranchDto = undefined
  portOfLading?: PortOfLadingDto = undefined
  portOfEntry?: PortOfEntryDto = undefined
}

export const InboundTripImportBranchValidationSchema = yup.object<InboundTripImportBranchDto>({
  importBranch: yup.object().required('Import Branch is required.'),
  portOfLading: yup.object().required('Port of Lading is required.'),
  portOfEntry: yup.object().required('Port of Entry is required.')
})
